import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { TimeMeasurementValue } from '@ulysses-inc/harami_api_client'
import React from 'react'
import { formatMinutes } from 'src/exShared/util/report/formatMinutes'
import BreakText from '../../BreakText'
import Col from '../../Col'
import Grid from '../../Grid'
import RecordedTime from './RecordedTime'

interface OwnProps {
  questionName: string
  timeMeasurementValue?: TimeMeasurementValue
  recordedAt?: Date
  isTimeDisplayed: boolean
}

const styles = StyleSheet.create({
  gridLeft: { width: '70%' },
  gridRight: { width: '30%' },
  grid: { width: '100%' },
  answerValueWrap: { width: '100%', marginBottom: 5 },
  answerValueText: { paddingLeft: 5, paddingTop: 5 },
  recordedTimeWrap: { width: '100%', marginBottom: 5 },
})

const TimeMeasurement: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <Grid style={styles.grid}>
      <Col borderLeft borderRight style={styles.gridLeft}>
        <BreakText text={props.questionName} />
      </Col>
      <Col borderRight style={{ ...styles.gridRight }}>
        <View style={styles.answerValueWrap}>
          <Text style={styles.answerValueText}>
            {`回答: ${
              props.timeMeasurementValue !== undefined
                ? formatMinutes(props.timeMeasurementValue.value)
                : '未回答'
            }`}
          </Text>
        </View>
        <View style={styles.recordedTimeWrap}>
          <RecordedTime
            isTimeDisplayed={props.isTimeDisplayed}
            recordedAt={props.recordedAt}
          />
        </View>
      </Col>
    </Grid>
  )
}

export default TimeMeasurement
